"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sentiment = void 0;
/**
 * The inferred sentiment (on a text) on which Amazon Comprehend has the highest level of confidence in.
 */
var Sentiment;
(function (Sentiment) {
    Sentiment["POSITIVE"] = "POSITIVE";
    Sentiment["NEGATIVE"] = "NEGATIVE";
    Sentiment["NEUTRAL"] = "NEUTRAL";
    Sentiment["MIXED"] = "MIXED";
})(Sentiment || (exports.Sentiment = Sentiment = {}));
